import { xml2js } from 'xml-js'

/**
 * getKidInContentProtection parse ContentProtection part of manifest to find the Kid
 * @param {Object|Array} contentProtection object of manifest to parse
 * @returns first KID found in manifest
 */
const getKidInContentProtection = (contentProtection) => {
    if (!contentProtection) {
        return undefined
    }
    const KIDTAG = 'cenc:default_KID'
    if (Array.isArray(contentProtection)) {
        for (
            let contentProtectionIndex = 0;
            contentProtectionIndex < contentProtection.length;
            contentProtectionIndex++
        ) {
            const contentProtectionItem = contentProtection[contentProtectionIndex]
            if (contentProtectionItem) {
                const attributes = contentProtectionItem._attributes
                if (attributes) {
                    const kid = attributes[KIDTAG]
                    if (kid) return kid
                }
            }
        }
    } else {
        const attributes = contentProtection._attributes
        if (attributes) {
            const kid = attributes[KIDTAG]
            if (kid) return kid
        }
    }
}

/**
 * getKidInRepresentation parse Representation part of mainfets to find the Kid
 * @param {Object|Array} representation object of manifest to parse
 * @returns first KID found in manifest
 */
const getKidInRepresentation = (representation) => {
    if (!representation) {
        return
    }
    if (Array.isArray(representation)) {
        for (
            let representationIndex = 0;
            representationIndex < representation.length;
            representationIndex++
        ) {
            const contentProtection = representation[representationIndex].ContentProtection
            const kid = getKidInContentProtection(contentProtection)
            if (kid) return kid
        }
    } else {
        const contentProtection = representation.ContentProtection
        const kid = getKidInContentProtection(contentProtection)
        if (kid) return kid
    }
}

/**
 * getKidInAdaptationSet parse AdaptationSet part of mainfets to find the Kid
 * @param {Object|Array} adaptationSet object of manifest to parse
 * @returns first KID found in manifest
 */
const getKidInAdaptationSet = (adaptationSet) => {
    if (Array.isArray(adaptationSet)) {
        for (
            let adaptationSetIndex = 0;
            adaptationSetIndex < adaptationSet.length;
            adaptationSetIndex++
        ) {
            const representation = adaptationSet[adaptationSetIndex].Representation
            const kid = getKidInRepresentation(representation)
            if (kid) return kid
        }
    } else {
        const representation = adaptationSet.Representation
        return getKidInRepresentation(representation)
    }
}

/**
 * getKidFromManifest parser input manifest and return first tag 'cenc:default_KID'
 * @param {String} manifest to parse
 * @returns first KID found in manifest
 */
const getKidFromManifest = (manifest) => {
    if (!manifest) {
        return undefined
    }
    try {
        const parsedManifest = xml2js(manifest, { compact: true })
        if (!parsedManifest) {
            return undefined
        }
        const mpd = parsedManifest.MPD
        if (!mpd) {
            return undefined
        }
        const period = mpd.Period
        if (!period) {
            return undefined
        }
        const adaptationSet = period.AdaptationSet
        if (!adaptationSet) {
            return undefined
        }
        return getKidInAdaptationSet(adaptationSet)
    } catch (e) {
        // this.logger.error('failure to parse manifest')
    }
}

export { getKidFromManifest }
